export const METRICS_CONTEXT_NAME = 'content-analytics';
